
import '../Services.css';
import img from '../../../assets/catogory/Commercial_Plots/img3.webp'; // Investment/Office image
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const RealEstateInvestment = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Real Estate Investment</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Real Estate Investment</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of real estate investment—guiding you towards high-return opportunities. Whether you are a first-time investor or building a portfolio, our comprehensive market analysis ensures secure, transparent, and profitable decisions.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Real Estate Investment" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Investment Goals</h3>
                            <p>We start by defining your investment objectives, risk tolerance, and financial horizon to tailor our approach.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Opportunity Identification</h3>
                            <p>Our experts scout the market for high-potential properties, land parcels, and development projects.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Financial Analysis</h3>
                            <p>We conduct rigorous financial modeling, projecting ROIs, cash flows, and appreciation potential to validate investments.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Due Diligence</h3>
                            <p>We perform comprehensive legal and physical due diligence to ensure the asset is secure and free of encumbrances.</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Acquisition</h3>
                            <p>We handle the negotiation and transaction process, securing the asset at the best possible terms.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Portfolio Management</h3>
                            <p>Post-acquisition, we offer strategies for asset management and eventual exit to maximize your returns.</p>
                        </div>
                    </div>
                </div>
            </div>

            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default RealEstateInvestment;
